import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/industries/EducationIndustries.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/Partials/DynamicPortfolio.tsx");
